// extracted by mini-css-extract-plugin
module.exports = {"button":"LatestPopular_button__yjf10","wrapper":"LatestPopular_wrapper__DikLZ","carousel":"LatestPopular_carousel__NCcgJ","controls":"LatestPopular_controls__gSbvI"};